export default __webpack_public_path__ + "locales/ro/Ldap.json?hash=1316e49a8ee1e1e919daf1cb7af82f59";